// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesNeo4jDatabaseCounts
 */
export interface TypesNeo4jDatabaseCounts {
  /**
   *
   * @type {number}
   * @memberof TypesNeo4jDatabaseCounts
   */
  currentNodes?: number;
  /**
   *
   * @type {number}
   * @memberof TypesNeo4jDatabaseCounts
   */
  currentRelationships?: number;
  /**
   *
   * @type {string}
   * @memberof TypesNeo4jDatabaseCounts
   */
  lastUpdate?: string;
}

/**
 * Check if a given object implements the TypesNeo4jDatabaseCounts interface.
 */
export function instanceOfTypesNeo4jDatabaseCounts(
  value: object,
): value is TypesNeo4jDatabaseCounts {
  return true;
}

export function TypesNeo4jDatabaseCountsFromJSON(
  json: any,
): TypesNeo4jDatabaseCounts {
  return TypesNeo4jDatabaseCountsFromJSONTyped(json, false);
}

export function TypesNeo4jDatabaseCountsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesNeo4jDatabaseCounts {
  if (json == null) {
    return json;
  }
  return {
    currentNodes:
      json['CurrentNodes'] == null ? undefined : json['CurrentNodes'],
    currentRelationships:
      json['CurrentRelationships'] == null
        ? undefined
        : json['CurrentRelationships'],
    lastUpdate: json['LastUpdate'] == null ? undefined : json['LastUpdate'],
  };
}

export function TypesNeo4jDatabaseCountsToJSON(
  json: any,
): TypesNeo4jDatabaseCounts {
  return TypesNeo4jDatabaseCountsToJSONTyped(json, false);
}

export function TypesNeo4jDatabaseCountsToJSONTyped(
  value?: TypesNeo4jDatabaseCounts | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    CurrentNodes: value['currentNodes'],
    CurrentRelationships: value['currentRelationships'],
    LastUpdate: value['lastUpdate'],
  };
}
